// extracted by mini-css-extract-plugin
export default {"landingPageBanner":"LandingPageBanner_landingPageBanner__s3Jk+","text":"LandingPageBanner_text__TY8IY","image":"LandingPageBanner_image__Nv92V"};